import { Button, Space, Card, Select, Col, Row, Layout, Table, Empty, InputNumber, Tooltip, Divider, Descriptions,Typography } from 'antd';

import React, { useEffect, useState } from 'react';

import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import {Link, useLocation} from 'react-router-dom';
import { RejectionDto, RejectionRequest} from '@gtpl/shared-models/production-management';

import { RejectionsService } from '@gtpl/shared-services/production';




import './qa-qc-sample-detail-view.css';

/* eslint-disable-next-line */
export interface QaQcSampleDetailViewProps {}

export function QaQcSampleDetailView(
  props: QaQcSampleDetailViewProps
) {
  
 
  const [qaQcDetailViewData, setQaQcDetailViewData] = useState<RejectionDto>();
 
  const rejectionService = new RejectionsService;
  let location = useLocation();
  const rejectionId :any= location.state;
  
  useEffect(() => {
    if(rejectionId){
      getDetailViewById(rejectionId.rejectionId);
      console.log(rejectionId);
    }
  }, [rejectionId]);

  const getDetailViewById = (rejectionId) => {
    const req = new RejectionRequest();
    req.rejectionId =rejectionId;
   
    rejectionService.getDetailViewById(req).then((res) => {
      if (res.status) {
        setQaQcDetailViewData(res.data);
        
      } 
    })
  }

  return (
    <>
    {
      <Layout style={{ padding: 10, backgroundColor: 'white', border: 10 }}>
        <Card title='QAQC Sample Detail View' style={{ textAlign: 'center'}} headStyle={{ backgroundColor: '#69c0ff',fontSize:'15px',color:'white'  }} extra={<Link to='/qa-qc-sample-test-grid' ><span style={{ color: 'white' }} ><Button className='panel_button' >View </Button> </span></Link>} size='small'> 
        { qaQcDetailViewData?<div>
          <Descriptions column={3}>
            <Descriptions.Item label="LOT Code">
              {qaQcDetailViewData?.lotNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Product">
            {qaQcDetailViewData?.product}
            </Descriptions.Item>
            <Descriptions.Item label="Sale Order Number">
              {qaQcDetailViewData?.saleOrderNumber}
            </Descriptions.Item>
           
            <Descriptions.Item label="Shift">
              {qaQcDetailViewData?.shift}
            </Descriptions.Item>
            <Descriptions.Item label="Operation">
              {qaQcDetailViewData?.operation}
            </Descriptions.Item>
            <Descriptions.Item label="Workstation">
              {qaQcDetailViewData?.workstationName}
            </Descriptions.Item>
            <Descriptions.Item label="Test">
              {qaQcDetailViewData?.testName}
            </Descriptions.Item>
            <Descriptions.Item label="Samples">
              {qaQcDetailViewData?.samples}
            </Descriptions.Item>
            <Descriptions.Item label="Quantity Tested">
              {qaQcDetailViewData?.quantity}
            </Descriptions.Item>
            <Descriptions.Item label="Rejected Quantity">
              {qaQcDetailViewData?.rejectionQuantity}
            </Descriptions.Item>
            <Descriptions.Item label="Rejection Reason">
              {qaQcDetailViewData?.rejectionReason}
            </Descriptions.Item>
            <Descriptions.Item label="Test Result">
              {qaQcDetailViewData?.testResult}
            </Descriptions.Item>
           
            
          </Descriptions>

          </div>:<div></div>}
        </Card><br></br>
      </Layout>
  }
</>
  );
}

export default QaQcSampleDetailView;
